import { render } from "./FlowSteps.vue?vue&type=template&id=5b1eb3a4"
import script from "./FlowSteps.vue?vue&type=script&lang=js"
export * from "./FlowSteps.vue?vue&type=script&lang=js"
script.render = render

export default script